import { AttackEvent, AttackType } from '../types/attack-event'
import { AttackStatus } from '../types/attack-status'

let id = 0
export function buildMockAttackEvent({
  ruleUuid = 'csrf',
  displayName = 'Some Display Name',
  result,
  sourceIP,
  sourceName = null,
  attackType = AttackType.AUTOMATED,
  attackers = [],
  userInput,
  type = 'PR',
  received = '1234',
  application = {
    id: '1',
    name: 'WebGoat'
  },
  server = {
    id: '1',
    name: 'Somebody-MacBook-Pro-2.local'
  },
  url = '/WebGoat/attack',
  suppressed = false,
  tags = []
}: Partial<AttackEvent>): AttackEvent {
  return {
    id: `${id++}`,
    ruleUuid,
    displayName,
    result: result as AttackStatus,
    sourceIP,
    sourceName,
    attackType,
    attackers,
    userInput: {
      name: '',
      value: '',
      type: 'UNKNOWN',
      omittedValue: false,
      truncatedValue: false,
      ...userInput
    },
    type,
    received,
    application,
    server,
    url,
    suppressed,
    tags,
    hasExclusion: false
  }
}

const generateTags = (n: number) =>
  Array.from(Array(n).keys()).map((n) => `Tag ${n + 1}`)

export const mockAttackEvents = [
  buildMockAttackEvent({
    result: 'EXPLOITED',
    displayName: 'Lorem ipsum dolor sit amet consectetur elit sed do eiusmod',
    sourceIP: '127.0.0.1',
    attackType: AttackType.AUTOMATED,
    ruleUuid: 'cmd-injection',
    userInput: {
      value: `"' & ping 192.168.0.1`
    },
    attackers: ['guest']
  }),
  buildMockAttackEvent({
    result: 'BLOCKED',
    displayName: 'Command Injection',
    sourceIP: '0:0:0:0:0:0:0:1',
    attackType: AttackType.MANUAL,
    ruleUuid: 'cmd-injection',
    userInput: {
      value: `"' & ping 192.168.0.1`
    },
    attackers: ['guest'],
    tags: generateTags(3)
  }),
  buildMockAttackEvent({
    result: 'BLOCKED_PERIMETER',
    displayName: 'Cross-Site Scripting',
    sourceIP: '127.0.0.1',
    ruleUuid: 'reflected-xss',
    userInput: {
      value: `" onmouseover="alert(wpcok948)`
    },
    attackers: ['guest', 'guest012', 'admin', 'editor', 'pwned']
  }),
  buildMockAttackEvent({
    result: 'EXPLOITED',
    displayName: 'Zip File Overwrite',
    sourceIP: '',
    ruleUuid: 'zip-file-overwrite',
    userInput: {
      value:
        '{&quot;lastUpdate&quot;:1562678783995,&quot;inventory&quot;:{&quot;libraries&quot;:[],&quot;technologies&quot;:[&quot;Struts&quot;],&quot;routes&quot;:[],&quot;urls&quot;:[&quot;/durango/do/candidate/read&quot;,&quot;/durango/do/form/list/candidate&quot;,&quot;/durango/do/candidate/aps/certprogress&quot;,&quot;/durango/do/form/save/candidate&quot;,&quot;/durango/do/candidate/landingpage&quot;,&quot;/durango/do/candidatemanager/findcandidate&quot;,&quot;/durango/do/login/accountRecovery&quot;,&quot;/durango/do/pr/prSearch&quot;,&quot;/durango/do/login&quot;,&quot;/durango/do/candidate/registrat',
      truncatedValue: true
    }
  }),
  buildMockAttackEvent({
    result: 'PROBED',
    displayName: 'Cross Site Request Forgery',
    sourceIP: '206.254.71.144',
    ruleUuid: 'csrf',
    userInput: {
      value: 'test attack value'
    }
  }),
  buildMockAttackEvent({
    result: 'PROBED_PERIMETER',
    displayName: 'Regular Expression DoS',
    sourceIP: '66.83.137.40',
    ruleUuid: 'redos',
    userInput: {
      value: 'test attack value'
    }
  }),
  buildMockAttackEvent({
    result: 'BLOCKED',
    displayName: 'VP: 67bc19e6-61c9-4aac-a48a-244179b01ce0',
    ruleUuid: 'VP: 67bc19e6-61c9-4aac-a48a-244179b01ce0',
    type: 'VP',
    sourceName: undefined,
    userInput: undefined
  })
]
